﻿import { Component, OnInit, HostListener } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Observable , interval } from "rxjs";
import { switchMap, map } from 'rxjs/operators';
import { DataService } from "../services/dataService";

declare var window: any;
declare var $: any;
declare var displayAlert: Function

@Component({
    selector: "jax-dashboard",
    templateUrl: "./dashboard.component.html",
})
export class DashboardComponent implements OnInit {


    public isActive = false;
    public showMenu: string = "";
    public subMenuItem: string = "My Work";
    public currentUser: any;
    public submenus: any;
    public isCaseDetail: boolean;
    public isCompleted: boolean;
    public newDocumentCount : number=0;

    public activeMenu: boolean[] = [false, false, false, false, false, false, false, false, false, false, false,false,false];
    public activeMenuDesc: string[] = ["My Work", "Notification", "Search Case(s)", "Search Calendar(s)", "Case Manager Admin", "Request Order", "Email Court Administration", "Location Information", "My Settings", "Help", "Logout", "Reports", "parentprofile",""];

    constructor(private route: ActivatedRoute, private dataService: DataService, private router: Router) {
        this.updateNotificationCount();
        interval(1800000).subscribe(x => {
            this.updateNotificationCount();
        });
    }
    
    public ngOnInit() {
       
        if (!location) {
            return;
        }
        
        if (location.href.indexOf("mywork") > -1) {
            this.activeMenu[0] = true;
        } else if (location.href.indexOf("notification") > -1) {
            this.activeMenu[1] = true;
        } else if (location.href.indexOf("searchcase") > -1) {
            this.activeMenu[2] = true;
        } else if (location.href.indexOf("searchcalendar") > -1) {
            this.activeMenu[3] = true;
        } else if (location.href.indexOf("casemanageradmin") > -1) {
            this.activeMenu[4] = true;
        } else if (location.href.indexOf("setpph") > -1) {
            this.activeMenu[5] = true;
        } else if (location.href.indexOf("emailcourtadmin") > -1) {
            this.activeMenu[6] = true;
        } else if (location.href.indexOf("locationinfo") > -1) {
            this.activeMenu[7] = true;
        } else if (location.href.indexOf("mysettings") > -1) {
            this.activeMenu[8] = true;
        } else if (location.href.indexOf("logout") > -1) {
            this.activeMenu[9] = true;
        } else if (location.href.indexOf("reports") > -1) {
            this.activeMenu[11] = true;
        } else if (location.href.indexOf("courtinformation") > -1) {
                this.activeMenu[12] = true;
        } else if (location.href.indexOf("parentprofile") > -1) {
                this.activeMenu[13] = true;
        } else {
            //this.activeMenu[0] = true;
        } 

        this.isCaseDetail = false;
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
        this.isCompleted = false;
        if (this.currentUser) {
            // this.dataService.get("common/menus?LoginName=" + this.currentUser.LoginName).subscribe((resp) => {
            //     this.submenus = resp;
            //     this.isCompleted = true;
            // });

        } else {
        }

    }

    public onMenuClick(menuIndex:number) {
        for (let index = 0; index < this.activeMenu.length; index++) {
            this.activeMenu[index] = false;
        }
        this.activeMenu[menuIndex] = true;    
        
        this.subMenuItem = this.activeMenuDesc[menuIndex];
    }


    public getLoginName(screenMode: number): string {
        if (screenMode === 1) {
            return this.currentUser.FirstName + " " + this.currentUser.LastName;
        } else {
            return this.currentUser.FirstName.substring(0, 1) + "" + this.currentUser.LastName.substring(0, 1);
        }
    }


    public eventCalled() {
        this.isActive = !this.isActive;
    }

    public addExpandClass(element: any) {
        if (element === this.showMenu) {
            this.showMenu = "0";
        } else {
            this.showMenu = element;
        }
    }

    public changeTheme(color: string): void {
        let link: any = $("<link>");
        link
            .appendTo("head")
            .attr({ type: "text/css", rel: "stylesheet" })
            .attr("href", "themes/app-" + color + ".css");
    }

    public rtl(): void {
        let body: any = $("body");
        body.toggleClass("rtl");
    }

    public sidebarToggler(): void {
        let sidebar: any = $("#sidebar");
        let mainContainer: any = $(".main-container");
        sidebar.toggleClass("sidebar-left-zero");
        mainContainer.toggleClass("main-container-ml-zero");
    }

    public logout(): void {
        this.dataService.redirectionStatus = 1;
        this.currentUser = null;
        localStorage.clear();
        sessionStorage.clear();
        this.router.navigate(["../login"], { relativeTo: this.route });
        window.showAlert = false;
        displayAlert();
    }

    public getHelpPdfUrl(helpindex: number): string {
        if (helpindex == 1 && (this.currentUser.Security.search("vintJAXPortalAccess")>=0 ||  this.currentUser.Security.search("vintJAXLimitedPortalAccess")>=0)) {
            return this.dataService.serviceUrl + "//jax.service/Help/JAXUserGuide.pdf";
        }
        else  if (helpindex == 1 && (this.currentUser.Security.search("vintJAXParentPortalAccess")>=0)) {
            return this.dataService.serviceUrl + "//jax.service/Help/JAXParentGuide.pdf";
        } else {
            return this.dataService.serviceUrl + "//jax.service/Help/UserManualROv1.0.pdf";
        }
    }

    public displayRemovalRequestMenu():boolean{
       return this.currentUser.Security.search("vintJAXRemovalRequestAccess")>=0 
    }

    public displayMyWorkMenu():boolean{
        return this.currentUser.Security.search("vintJAXMyWorkView")>=0 
     }

     public displayMyCaseParentMenu():boolean{
        return this.currentUser.Security.search("vintJAXParentPortalAccess")>=0 
     }

    private updateNotificationCount(): void {
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
        if (this.currentUser) {
            this.dataService.get("document/distributeddocument?userId=" + this.currentUser.UserId).subscribe((resp) => {
                this.newDocumentCount = resp;
            },
            (error) => {
                this.isCompleted = true;
            });
        }
    }
}
